export const state = {
	error: null
}

export const mutations = {
	clearError: state => {
		state.error = null
	},
	setError: (state, payload) => {
		if (!state.error || (!state.error.hard && payload.hard)) {
			state.error = payload
			return
		}

		if (process.env.NODE_ENV !== 'production') {
			console.error({ error: payload })
		}
	}
}

export const getters = {
	getMustShowErrors: state => {
		return state.error !== null
	},
	getError: state => {
		return state.error
	}
}

export const actions = {}
